import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    createAttachment({ commit, state }, { formData, fileName }) {
        if (formData !== null) {
            const cancelToken = axios.CancelToken
            const cancelTokenSource = cancelToken.source()

            commit('SET_CANCEL_TOKEN', {
                token: cancelTokenSource,
                fileName: fileName
            })
        } else {
            commit('ABORT_FILE_UPLOAD', fileName)
        }

        const tokenIndex = state.uploadCancelTokens.findIndex(item => item.fileName === fileName)

        commit('FILE_PROGRESS', {
            show: true,
            value: 0,
            fileName: fileName
        }, { root: true })

        return axios
            .post('/complaints/complaints/file/upload', formData, {
                cancelToken: state.uploadCancelTokens[tokenIndex].token.token,
                timeout: 900000, // 15 min
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    commit('FILE_PROGRESS', {
                        show: true,
                        value: percentCompleted,
                        fileName: fileName
                    }, { root: true })
                }
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                if (error.message !== 'canceled') {
                    handleApiError(error, 'Dodanie załącznika nie powiodło się.')
                }

                return Promise.reject(error)
            })
            .finally(() => {
                commit('REMOVE_CANCEL_TOKEN', tokenIndex)
                commit('FILE_PROGRESS', {
                    show: false,
                    value: 0,
                    fileName: null
                }, { root: true })
            })
    },

    deleteAttachment(_, id) {
        return axios
            .delete(`/complaints/complaints/file/upload/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie załącznika nie powiodło się.')

                return Promise.reject(error)
            })
    },
}
